import { TableCell, TableRow } from "@mui/material";
import styled from "styled-components";

export const STableRow = styled(TableRow)`
  && {
    align-items: center;
    min-height: 32px;
  }
`;

export const SCell = styled(TableCell)`
  && {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.periodButtonDark};
    border-bottom: 0px;
    padding: 8px;
    height: 100%;
    text-align: center;
  }
`;

export const SFirstColumnCell = styled(TableCell)`
  && {
    display: flex;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.periodButtonDark};
    border-bottom: 0px;
    padding: 8px;
    height: 100%;
    text-align: left;
    min-width: fit-content;
    align-items: center;
  }
`;

interface SBarPropsTypes {
  $barColor: string;
}

export const SBar = styled.div<SBarPropsTypes>`
  height: 16px;
  width: 4px;
  min-width: 4px;
  content: "";
  background-color: ${({ $barColor }) => $barColor || "black"};
  margin-right: 10px;
`;
